var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleplay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 40,
    fill: "none",
    viewBox: "0 0 139 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#8C8C8C",
    d: "M5.621 39.38H133.65c2.477 0 4.495-1.98 4.495-4.38V5c0-2.4-2.018-4.38-4.495-4.38H5.621C3.145.62 1.127 2.6 1.127 5v30c0 2.4 2.018 4.38 4.494 4.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.066 10.244c0 .835-.257 1.503-.761 2.002q-.871.888-2.261.889c-.885 0-1.64-.303-2.26-.899-.62-.605-.93-1.347-.93-2.236q0-1.332.93-2.231.931-.904 2.26-.904c.44 0 .86.089 1.261.254.4.166.725.39.96.668l-.535.528q-.613-.71-1.686-.708-.968-.001-1.68.664-.705.667-.705 1.729c0 .707.235 1.289.705 1.734a2.4 2.4 0 0 0 1.68.663c.685 0 1.261-.225 1.716-.668q.449-.441.514-1.217h-2.23V9.79h2.975c.036.156.047.307.047.454M53.786 7.739h-2.795v1.9h2.52v.722h-2.52v1.9h2.795v.736H50.2V7.002h3.586zM57.117 12.997h-.791V7.74H54.61v-.737h4.221v.737h-1.715zM61.887 12.997V7.002h.79v5.995zM66.18 12.998h-.786v-5.26h-1.72v-.735H67.9v.736h-1.72zM75.892 12.226q-.908.909-2.25.909-1.349 0-2.256-.909-.906-.907-.905-2.226-.001-1.318.905-2.226.907-.91 2.255-.91 1.336-.002 2.246.915c.61.61.91 1.347.91 2.22q.001 1.32-.905 2.227m-3.921-.502c.456.448 1.01.673 1.67.673.656 0 1.215-.225 1.666-.673q.684-.675.685-1.724-.001-1.05-.685-1.724c-.45-.449-1.01-.674-1.666-.674q-.989 0-1.67.674-.684.674-.685 1.724.001 1.05.685 1.724M77.905 12.997V7.002h.96l2.986 4.663h.035l-.035-1.153v-3.51h.79v5.995h-.824L78.69 8.105h-.034l.034 1.157v3.735zM70.285 21.753c-2.405 0-4.37 1.787-4.37 4.253 0 2.447 1.965 4.253 4.37 4.253 2.411 0 4.376-1.806 4.376-4.253 0-2.466-1.965-4.253-4.376-4.253m0 6.83c-1.32 0-2.455-1.063-2.455-2.577 0-1.533 1.135-2.579 2.455-2.579s2.46 1.046 2.46 2.58c0 1.513-1.14 2.577-2.46 2.577m-9.537-6.83c-2.41 0-4.37 1.787-4.37 4.253 0 2.447 1.96 4.253 4.37 4.253s4.371-1.806 4.371-4.253c0-2.466-1.961-4.253-4.37-4.253m0 6.83c-1.32 0-2.46-1.063-2.46-2.577 0-1.533 1.14-2.579 2.46-2.579s2.456 1.046 2.456 2.58c0 1.513-1.136 2.577-2.456 2.577M49.4 23.057v1.808h4.42c-.129 1.01-.474 1.752-1.004 2.27-.646.625-1.65 1.319-3.416 1.319-2.72 0-4.851-2.144-4.851-4.8 0-2.657 2.13-4.8 4.85-4.8 1.472 0 2.542.56 3.332 1.288l1.305-1.273c-1.105-1.03-2.575-1.822-4.636-1.822-3.73 0-6.866 2.964-6.866 6.607 0 3.642 3.135 6.606 6.866 6.606 2.016 0 3.53-.645 4.722-1.855 1.22-1.192 1.6-2.866 1.6-4.219 0-.42-.036-.806-.1-1.129zm46.405 1.401c-.36-.95-1.47-2.704-3.73-2.704-2.241 0-4.106 1.723-4.106 4.253 0 2.383 1.846 4.253 4.32 4.253a4.34 4.34 0 0 0 3.631-1.885l-1.485-.966c-.495.707-1.17 1.176-2.145 1.176-.97 0-1.665-.434-2.11-1.289l5.826-2.354zm-5.94 1.417a2.36 2.36 0 0 1 2.275-2.48c.76 0 1.406.371 1.62.902zM85.129 30h1.915V17.5H85.13zm-3.137-7.3h-.064c-.43-.497-1.25-.947-2.29-.947-2.182 0-4.177 1.87-4.177 4.267 0 2.384 1.995 4.239 4.177 4.239 1.04 0 1.86-.454 2.29-.966h.064v.61c0 1.626-.89 2.5-2.325 2.5-1.17 0-1.896-.825-2.195-1.52l-1.666.68c.48 1.127 1.751 2.515 3.861 2.515 2.246 0 4.14-1.29 4.14-4.43v-7.637h-1.815zm-2.19 5.884c-1.32 0-2.425-1.079-2.425-2.564 0-1.499 1.105-2.593 2.425-2.593 1.3 0 2.326 1.094 2.326 2.593 0 1.485-1.026 2.564-2.326 2.564m24.97-11.084h-4.581V30h1.911v-4.736h2.67c2.122 0 4.202-1.499 4.202-3.883 0-2.382-2.085-3.881-4.202-3.881m.05 6.025h-2.72v-4.286h2.72a2.195 2.195 0 0 1 2.241 2.142c0 .968-.814 2.144-2.241 2.144m11.808-1.796c-1.38 0-2.815.595-3.405 1.913l1.695.694c.365-.694 1.036-.918 1.745-.918.991 0 1.996.58 2.011 1.607v.131c-.345-.195-1.085-.483-1.996-.483-1.825 0-3.686.98-3.686 2.812 0 1.675 1.496 2.754 3.177 2.754 1.285 0 1.994-.567 2.44-1.225h.065v.966h1.845v-4.795c0-2.216-1.695-3.456-3.891-3.456m-.23 6.85c-.625 0-1.495-.303-1.495-1.059 0-.968 1.085-1.339 2.025-1.339.841 0 1.235.181 1.746.42-.15 1.158-1.17 1.978-2.276 1.978m10.843-6.576-2.196 5.418h-.065l-2.27-5.418h-2.06l3.41 7.572-1.946 4.214h1.996l5.256-11.786zM110.024 30h1.915V17.5h-1.915z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleplay_svg__a)",
    d: "M11.19 7.539c-.301.307-.475.786-.475 1.406V31.06c0 .62.174 1.099.475 1.406l.074.068 12.693-12.388v-.292L11.264 7.466z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleplay_svg__b)",
    d: "m28.183 24.277-4.226-4.13v-.293l4.231-4.132.095.054 5.011 2.784c1.43.79 1.43 2.09 0 2.885l-5.01 2.779z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleplay_svg__c)",
    d: "M28.28 24.224 23.954 20 11.187 32.466c.475.488 1.25.547 2.13.059z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleplay_svg__d)",
    d: "M28.28 15.776 13.317 7.475c-.88-.482-1.655-.424-2.13.064L23.954 20z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleplay_svg__a",
    x1: 22.83,
    x2: 6.052,
    y1: 31.29,
    y2: 14.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleplay_svg__b",
    x1: 35.156,
    x2: 10.373,
    y1: 19.998,
    y2: 19.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleplay_svg__c",
    x1: 25.927,
    x2: 3.175,
    y1: 17.704,
    y2: -5.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleplay_svg__d",
    x1: 7.973,
    x2: 18.133,
    y1: 39.824,
    y2: 29.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
};
export default SvgGoogleplay;